import {
  getLangFromBrowser,
  getLangFromUrl,
  getLanguageFromLocalStorage,
} from 'utils/i18n';

import { ensureI18nInitialized, useI18n } from './stores/i18n';

export class Translator {
  static async setLanguageCode(
    preferredLanguage: string,
    source: string,
  ): Promise<void> {
    ensureI18nInitialized();
    await useI18n.getState().setLang(preferredLanguage, source);
  }

  static getLanguageCode(): string {
    ensureI18nInitialized();
    return useI18n.getState().lang;
  }

  static getLanguageSource(): string {
    ensureI18nInitialized();
    const currentLang = useI18n.getState().lang;
    const langFromUrl = getLangFromUrl();
    const langFromStorage = getLanguageFromLocalStorage();
    const langFromBrowser = getLangFromBrowser();
    if (currentLang === langFromUrl) return 'url';
    if (currentLang === langFromStorage) return 'storage';
    if (currentLang === langFromBrowser) return 'browser';
    return 'default';
  }

  static getDateLocale() {
    ensureI18nInitialized();
    return useI18n.getState().dateLocale;
  }

  static translateText(
    translateKey: string,
    replacement: any = {},
    defaultValue = '',
  ): string {
    ensureI18nInitialized();
    const { translate } = useI18n.getState();
    return translate(translateKey, replacement, {
      textOnly: true,
      defaultValue,
    }) as string;
  }

  static translate(
    translateKey: string,
    replacement: any = {},
    textOnly?: boolean,
    defaultValue?: string | JSX.Element,
  ): any {
    ensureI18nInitialized();
    const { translate } = useI18n.getState();
    return translate(translateKey, replacement, { textOnly, defaultValue });
  }

  static i18n(key: string, defaultText?: string): string {
    ensureI18nInitialized();
    const { t } = useI18n.getState();
    return t(key, defaultText);
  }
}

export { getLangFromUrl } from './utils/i18n';
